import { AfterViewInit, Component, Input, OnChanges } from '@angular/core';
import { createPlotlyChart } from 'src/app/_shared/plotlyConfig';

@Component({
  selector: 'app-battery-condition-chart',
  templateUrl: './battery-condition-chart.component.html',
  styleUrls: ['./battery-condition-chart.component.scss']
})
export class BatteryConditionChartComponent implements OnChanges, AfterViewInit {
  @Input() fleetId: string[] = [];
  @Input() chartId: string = 'battery-condition-chart';
  @Input() dataLoadingBCEvents!: boolean;
  @Input() errorMessageBCEvents!: boolean;
  @Input() batteryConditions!: any;
  errorMessageCurrentBatteryCondition: boolean = false;
  private viewReady = false;

  ngAfterViewInit(): void {
    this.viewReady = true;
    this.plotWhenReady();
  }

  ngOnChanges(): void {
    this.plotWhenReady();
  }

  private plotWhenReady(): void {
    if (this.viewReady && Object.keys(this.batteryConditions ?? {}).length !== 0) {
      this.plotBatteryCondition();
    }
  }

  plotBatteryCondition() {
    const data = Object.keys(this.batteryConditions).flatMap((fleetId: string) => {
      const plotData = this.batteryConditions[fleetId];
      if (!plotData) return {}
      const aboveCondition = plotData.batteryCondition.above;
      const averageCondition = plotData.batteryCondition.average;
      const belowCondition = plotData.batteryCondition.below;
      const undefinedCondition = plotData.batteryCondition.undefined;
      
      return {
        values: [aboveCondition, averageCondition, belowCondition, undefinedCondition],
        labels: ['Above average condition', 'Average condition', 'Below average condition', 'Rating still pending'],
        type: 'pie',
        marker: {
          colors: ['#00884A', '#007BC0', '#C535BC', '#B2B9C0']
        },
        hoverinfo: 'label+percent',
      }
    })

    if (data.every(d => Array.isArray(d.values) && d.values.every((v: any) => v === null))) {
      this.errorMessageCurrentBatteryCondition = true;
    } else {
      const layout = {
        title: 'Fleet Battery Condition - Today',
        font: {
          family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
          size: 13,
        },
        showlegend: true,
        legend: {
          orientation: 'h', 
          y: -0.3, 
          xanchor: 'center', 
          x: 0.5,
          font: {
            family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
            size: 13,
          },
          itemclick: false,
          itemdoubleclick: false,
        }
      };

      createPlotlyChart(this.chartId, data, layout);
    }
  }

}
